<template>
    <div style="height: calc(100vh - 56px); width: 100%; overflow-y: scroll">
        <div class="mx-auto mt-4" style="max-width: 1800px">
            <div>
                <CCol class="opp-table-wrapper">
                    <CCard>
                        <CCardHeader
                            style="
                                display: flex;
                                gap: 8px;
                                justify-content: flex-end;
                            "
                        >
                            <CButton
                                color="success"
                                @click="showCreateOpportunityModal = true"
                                style=""
                                >Add Opportunity
                            </CButton>
                            <CButton color="danger" @click="clearFiltersHandler"
                                >Clear Filters
                            </CButton>
                            <clientFilter
                                v-if="isSysAdmin || isGroupAdmin"
                                class="w-25"
                            />
                            <CButton
                                color="secondary"
                                @click="importModal = true"
                                >Import
                            </CButton>
                            <CButton color="secondary" @click="exportHandler"
                                >Export
                            </CButton>
                        </CCardHeader>
                        <CCardBody>
                            <ag-grid-vue
                                class="ag-theme-alpine"
                                style="height: 420px; width: 100%"
                                :columnDefs="columnDefs"
                                :rowData="oppTableData"
                                :defaultColDef="defaultColDef"
                                :pagination="true"
                                :paginationPageSize="selectedPageSize"
                                :suppressPaginationPanel="true"
                                :suppressMenuHide="true"
                                @grid-ready="onGridReady"
                            >
                            </ag-grid-vue>
                            <div class="custom-pagination">
                                <div class="pagination-left">
                                    <span>Items per page:</span>
                                    <v-select
                                        v-model="selectedPageSize"
                                        :options="pageSizeOptions"
                                        :clearable="false"
                                        :searchable="false"
                                        class="page-size-select"
                                        @input="onPageSizeChange"
                                    />
                                    <span>Total: {{ totalRows }} items</span>
                                </div>
                                <div class="pagination-right">
                                    <button
                                        class="pagination-btn"
                                        @click="onFirstPage"
                                        :disabled="currentPage === 1"
                                    >
                                        «
                                    </button>
                                    <button
                                        class="pagination-btn"
                                        @click="onPreviousPage"
                                        :disabled="currentPage === 1"
                                    >
                                        ‹
                                    </button>
                                    <span class="pagination-info">
                                        Page {{ currentPage }} of
                                        {{ totalPages }}
                                    </span>
                                    <button
                                        class="pagination-btn"
                                        @click="onNextPage"
                                        :disabled="currentPage === totalPages"
                                    >
                                        ›
                                    </button>
                                    <button
                                        class="pagination-btn"
                                        @click="onLastPage"
                                        :disabled="currentPage === totalPages"
                                    >
                                        »
                                    </button>
                                </div>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCol>

                <CElementCover v-if="spinner" :opacity="0.8" />
            </div>
        </div>

        <CModal
            title="Are you sure you want to delete?"
            :show.sync="showDeleteOpportunityModal"
            centered
            fade
            class="addCategoryModal"
            :closeOnBackdrop="false"
        >
            <br />
            <CButton
                type="submit"
                color="primary"
                class="m-1"
                @click="deleteOpportunity"
                :style="{ float: 'right' }"
            >
                Yes
            </CButton>
            <CButton
                type="submit"
                color="secondary"
                class="m-1"
                @click="showDeleteOpportunityModal = false"
                :style="{ float: 'right' }"
                >No
            </CButton>
        </CModal>

        <CModal
            title="Edit opportunity"
            :show.sync="showEditOpportunityModal"
            centered
            fade
            class="addCategoryModal"
            :closeOnBackdrop="false"
        >
            <CInputRadio
                type="radio"
                name="editOpportunityValue"
                id="dollar-opportunity"
                label="Dollar Opportunity ($)"
                @click="editOpportunityMode = 'dollar'"
                :checked="editOpportunityMode === 'dollar'"
            />
            <CurrencyInput
                class="radio-text-input"
                v-model="editingPrice"
                placeholder=""
                :disabled="editOpportunityMode !== 'dollar'"
            />
            <CInputRadio
                type="radio"
                name="editOpportunityValue"
                id="percent-opportunity"
                label="Percent Opportunity (%)"
                @click="editOpportunityMode = 'percent'"
                :checked="editOpportunityMode === 'percent'"
            />
            <PercentInput
                class="radio-text-input"
                v-model="editingPercent"
                placeholder=""
                :disabled="editOpportunityMode !== 'percent'"
            />
            <br />
            <CButton
                type="submit"
                color="primary"
                class="m-1"
                @click="updateOpportunity"
                :style="{ float: 'right' }"
            >
                Yes
            </CButton>
            <CButton
                type="submit"
                color="secondary"
                class="m-1"
                @click="showEditOpportunityModal = false"
                :style="{ float: 'right' }"
            >
                No
            </CButton>
        </CModal>

        <CModal
            title="Add opportunity"
            :show.sync="showCreateOpportunityModal"
            centered
            fade
            class="addCategoryModal"
            :closeOnBackdrop="false"
        >
            <strong class="input-error" v-if="addOppModalHasError">
                Please fill the required fields below!
                <br />
                <br />
            </strong>
            <div
                class="opportunity-input"
                :class="{
                    'input-error': !isValidForAddingOpp.clientForAddingOpp,
                }"
            >
                <label>Clients*:</label>
                <v-select
                    placeholder="Select a client"
                    :options="clientList"
                    :multiple="false"
                    v-model="clientForAddingOpp"
                />
            </div>
            <div>
                <CInput
                    class="opportunity-input"
                    :class="{
                        'input-error':
                            !isValidForAddingOpp.projectIdForAddingOpp,
                    }"
                    label="Project Number*:"
                    placeholder="Enter in format AA-000.000"
                    v-model="projectIdForAddingOpp"
                    @input="onInput"
                />
                <div v-if="errorMessage" class="error-message">
                    {{ errorMessage }}
                </div>
            </div>

            <CInput
                class="opportunity-input"
                :class="{
                    'input-error': !isValidForAddingOpp.groupForAddingOpp,
                }"
                label="Opportunity Group*:"
                placeholder=""
                v-model="groupForAddingOpp"
            />
            <CInput
                class="opportunity-input"
                :class="{
                    'input-error': !isValidForAddingOpp.categoryForAddingOpp,
                }"
                label="Opportunity Category*:"
                placeholder=""
                v-model="categoryForAddingOpp"
            />

            <br />
            <CInputRadio
                type="radio"
                name="addOpportunityValue"
                id="add-TBD-opportunity"
                label="Opportunity TBD"
                @click="modeForAddingOpp = 'TBD'"
                :checked="modeForAddingOpp === 'TBD'"
            />
            <CInputRadio
                type="radio"
                name="addOpportunityValue"
                id="add-dollar-opportunity"
                label="Dollar Opportunity"
                @click="modeForAddingOpp = 'dollar'"
                :checked="modeForAddingOpp === 'dollar'"
            />
            <CurrencyInput
                class="radio-text-input"
                v-model="priceForAddingOpp"
                placeholder=""
                :disabled="modeForAddingOpp !== 'dollar'"
            />
            <CInputRadio
                type="radio"
                name="addOpportunityValue"
                id="add-percent-opportunity"
                label="Percent Opportunity"
                @click="modeForAddingOpp = 'percent'"
                :checked="modeForAddingOpp === 'percent'"
            />
            <PercentInput
                class="radio-text-input"
                v-model="percentForAddingOpp"
                placeholder=""
                :disabled="modeForAddingOpp !== 'percent'"
            />
            <br />
            <CButton
                type="submit"
                color="primary"
                class="m-1"
                @click="createOppHandler"
                :style="{ float: 'right' }"
            >
                Yes
            </CButton>
            <CButton
                type="submit"
                color="secondary"
                class="m-1"
                @click="showCreateOpportunityModal = false"
                :style="{ float: 'right' }"
            >
                No
            </CButton>
        </CModal>
        <Import
            title="Import Opportunities"
            :modal="importModal"
            type="opportunity-data"
            :selectClient="true"
            @close="importModal = false"
        />
        <Import
            title="Import Opportunities"
            :modal="importItemsModal"
            type="items-data"
            :selectClient="false"
            :importData="editingItem"
            @close="importItemsModal = false"
        >
            <div class="row my-2">
                <label class="col-form-label col-sm-3 py-0 text-right"
                    >Client:</label
                >
                <div class="col-sm-9 py-0 pl-2 font-weight-bold">
                    {{ editingItem.client_name }}
                </div>
            </div>
            <div class="row my-2">
                <label class="col-form-label col-sm-3 py-0 text-right"
                    >Group:</label
                >
                <div class="col-sm-9 py-0 pl-2 font-weight-bold">
                    {{ editingItem.opportunity_group }}
                </div>
            </div>
            <div class="row my-2 mb-3">
                <label class="col-form-label col-sm-3 py-0 text-right"
                    >Category:</label
                >
                <div class="col-sm-9 py-0 pl-2 font-weight-bold">
                    {{ editingItem.opportunity_category }}
                </div>
            </div>
        </Import>
        <CModal
            title="Vendor List"
            :show.sync="showVendorsModal"
            centered
            fade
            size="lg"
            :closeOnBackdrop="true"
            class="vendor-modal"
        >
            <div class="vendor-modal-content">
                <div class="vendor-count">
                    <span class="font-weight-bold" style="font-size: 1.2rem"
                        ><strong>{{ selectedVendors.length }}</strong></span
                    >
                    Vendors
                </div>
                <div class="vendor-list">
                    <div
                        v-if="selectedVendors.length === 0"
                        class="vendor-item"
                    >
                        <div class="vendor-name">No vendor</div>
                    </div>
                    <div
                        v-else
                        v-for="(vendor, index) in selectedVendors"
                        :key="index"
                        class="vendor-item"
                    >
                        <div class="vendor-number">{{ index + 1 }}</div>
                        <div class="vendor-name">{{ vendor }}</div>
                    </div>
                </div>
            </div>
            <template #footer>
                <CButton
                    color="secondary"
                    @click="showVendorsModal = false"
                    class="px-4"
                >
                    Close
                </CButton>
            </template>
        </CModal>
    </div>
</template>

<script>
import _ from "../Utility/utility";
import gql from "graphql-tag";
import clientFilter from "../../components/clientFilter";
import store, { storeData } from "../../store";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { getSelectedClients } from "../../store";
import CurrencyInput from "../../components/CurrencyInput.vue";
import PercentInput from "../../components/PercentInput.vue";
import XLSX from "xlsx";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

export default {
    components: {
        AgGridVue,
        clientFilter,
        vSelect,
        CurrencyInput,
        PercentInput,
    },
    data() {
        return {
            gridApi: null,
            gridColumnApi: null, 
            columnDefs: [
                {
                    field: "project_id",
                    headerName: "Project",
                    filter: true,
                    sortable: true,
                    sort: 'asc',
                    editable: true,
                    cellEditor: 'agTextCellEditor',
                    onCellValueChanged: this.onProjectIdChanged,
                    tooltipValueGetter: (params) => 'Click to edit project number'
                },
                {
                    field: "included_vendors",
                    headerName: "Vendor",
                    filter: true,
                    sortable: true,
                    initialWidth: 210,
                    minWidth: 210,
                    width: 210,
                    cellRenderer: this.vendorCellRenderer,
                    onCellClicked: this.onVendorCellClicked,
                },
                {
                    field: "opportunity_category",
                    headerName: "Category",
                    filter: true,
                    sortable: true,
                    editable: true,
                    cellEditor: 'agTextCellEditor',
                    onCellValueChanged: this.onOpportunityCategoryChanged,
                    tooltipValueGetter: (params) => 'Click to edit category'
                },
                {
                    field: "opportunity_group",
                    headerName: "Project Name",
                    filter: true,
                    sortable: true,
                    editable: true,
                    cellEditor: 'agTextCellEditor',
                    onCellValueChanged: this.onOpportunityGroupChanged,
                    tooltipValueGetter: (params) => 'Click to edit group'
                },
                {
                    field: "sku_count",
                    headerName: "SKUs",
                    filter: true,
                    sortable: true,
                    initialWidth: 95,
                    minWidth: 95,
                    width: 95,
                    maxWidth: 100,
                },
                {
                    field: "total_spend",
                    headerName: "Spend",
                    filter: true,
                    sortable: true,
                    initialWidth: 150,
                    minWidth: 150,
                    width: 150,
                },
                {
                    field: "opportunity_set_status",
                    headerName: "Status",
                    filter: true,
                    sortable: true,
                    initialWidth: 150,
                    minWidth: 130,
                    width: 150,
                    maxWidth: 180,
                    editable: true,
                    cellEditor: "agSelectCellEditor",
                    cellEditorParams: {
                        values: []  // Will be populated dynamically
                    },
                    onCellValueChanged: this.onStatusChanged,
                    tooltipValueGetter: (params) => 'Click to edit status'
                },
                {
                    field: "potential_savings",
                    headerName: "Opportunity",
                    filter: true,
                    sortable: true,
                    initialWidth: 132,
                    minWidth: 132,
                    width: 132,
                    editable: true,
                    cellEditor: 'agTextCellEditor',
                    onCellValueChanged: this.onSavingsChanged,
                    tooltipValueGetter: (params) => 'Click to edit dollar savings'
                },
                {
                    field: "savings_percent",
                    headerName: "%",
                    filter: true,
                    sortable: true,
                    minWidth: 75,
                    width: 75,
                    maxWidth: 80,
                    editable: true,
                    cellEditor: 'agTextCellEditor',
                    onCellValueChanged: this.onPercentChanged,
                    tooltipValueGetter: (params) => 'Click to edit savings percentage'
                },
                {
                    field: "opportunity_priority",
                    headerName: "Priority",
                    filter: true,
                    sortable: true,
                    initialWidth: 100,
                    minWidth: 80,
                    width: 100,
                    maxWidth: 120,
                    editable: true,
                    cellEditor: "agSelectCellEditor",
                    cellEditorParams: {
                        values: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
                    },
                    onCellValueChanged: this.onPriorityChanged,
                    tooltipValueGetter: (params) => 'Click to edit priority'
                },
                {
                    headerName: "Action",
                    cellRenderer: this.actionCellRenderer,
                    sortable: false,
                    filter: false,
                    width: 170,
                    minWidth: 170,
                    maxWidth: 170,
                },
            ],
            defaultColDef: {
                flex: 1,
                minWidth: 75,
                filter: true,
                sortable: true,
                resizable: true,
            },
            rawData: [],
            oppTableData: [],
            spinner: false,
            clients: [],
            groups: [],
            statuses: [],
            showCreateOpportunityModal: false,
            editingItem: {},
            showEditOpportunityModal: false,
            showDeleteOpportunityModal: false,
            editOpportunityMode: "dollar",
            editingPrice: 0,
            editingPercent: 0,

            priceForAddingOpp: 0,
            percentForAddingOpp: 0,
            modeForAddingOpp: "dollar",
            clientForAddingOpp: "",
            groupForAddingOpp: "",
            projectIdForAddingOpp: "",
            categoryForAddingOpp: "",
            isValidForAddingOpp: {
                priceForAddingOpp: true,
                percentForAddingOpp: true,
                modeForAddingOpp: true,
                clientForAddingOpp: true,
                groupForAddingOpp: true,
                projectIdForAddingOpp: true,
                categoryForAddingOpp: true,
            },
            importModal: false,
            exportModal: false,
            importItemsModal: false,
            errorMessage: "",
            debounceTimer: null,
            selectedPageSize: 25,
            pageSizeOptions: [
                { label: "25", value: 25 },
                { label: "50", value: 50 },
                { label: "75", value: 75 },
                { label: "100", value: 100 },
            ],
            totalRows: 0,
            currentPage: 1,
            showVendorsModal: false,
            selectedVendors: [],
            projectStatusOptions: [],  // To store status options
        };
    },
    computed: {
        isSysAdmin() {
            return storeData.currentUserDetails.role.name === "sys_admin";
        },
        isGroupAdmin() {
            return storeData.currentUserDetails.role.name === "group_admin";
        },
        selectedClients() {
            return getSelectedClients();
        },
        clientList() {
            return storeData.clientList.filter((el) => el.label !== "All");
        },
        addOppModalHasError() {
            return (
                !this.isValidForAddingOpp.clientForAddingOpp ||
                !this.isValidForAddingOpp.groupForAddingOpp ||
                !this.isValidForAddingOpp.categoryForAddingOpp ||
                !this.isValidForAddingOpp.projectIdForAddingOpp
            );
        },
        isFilteredClients() {
            return !this.clients.every((c) => c.checked);
        },
        isFilteredGroups() {
            return !this.groups.every((g) => g.checked);
        },
        isFilteredStatuses() {
            return !this.statuses.every((s) => s.checked);
        },
        totalPages() {
            return Math.ceil(this.totalRows / this.selectedPageSize);
        },
    },
    watch: {
        async selectedClients() {
            this.spinner = true;
            await this.fetchOppTableData();
            this.spinner = false;
        },
        showEditOpportunityModal(newVal) {
            if (!newVal) {
                this.initEditOpportunityModal();
            }
        },
        showDeleteOpportunityModal(newVal) {
            if (!newVal) {
                this.editingItem = {};
            }
        },
        showCreateOpportunityModal(newVal) {
            if (!newVal) {
                this.priceForAddingOpp = 0;
                this.percentForAddingOpp = 0;
                this.modeForAddingOpp = "dollar";
                this.clientForAddingOpp = "";
                this.groupForAddingOpp = "";
                this.projectIdForAddingOpp = "";
                this.categoryForAddingOpp = "";
                this.isValidForAddingOpp = {
                    priceForAddingOpp: true,
                    percentForAddingOpp: true,
                    modeForAddingOpp: true,
                    clientForAddingOpp: true,
                    groupForAddingOpp: true,
                    projectIdForAddingOpp: true,
                    categoryForAddingOpp: true,
                };
            }
        },
        oppTableData(newData) {
            this.totalRows = newData.length;
        },
    },
    methods: {
        onInput(value) {
            this.projectIdForAddingOpp = value; // Use the value directly from the input event
            this.debounceValidation();
        },
        validateProjectId() {
            const regex = /^[A-Z]{2}-\d{3}\.\d{3}$/;
            this.isValidForAddingOpp.ProjectIdForAddingOpp = regex.test(
                this.projectIdForAddingOpp
            );

            if (!this.isValidForAddingOpp.ProjectIdForAddingOpp) {
                this.setErrorMessage();
            } else {
                this.errorMessage = "";
            }
        },
        setErrorMessage() {
            const lengthError = this.projectIdForAddingOpp.length < 12;
            const formatError = !/^[A-Z]{2}-\d{3}\.\d{3}$/.test(
                this.projectIdForAddingOpp
            );

            if (lengthError) {
                this.errorMessage =
                    "Input is too short. Ensure it follows the format AA-000.000.";
            } else if (formatError) {
                this.errorMessage = "Invalid format. Please use AA-000.000.";
            }
        },
        debounceValidation() {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                this.validateProjectId();
            }, 300);
        },

        handleCheckboxUpdate() {
            const checkedClientsValues = this.clients
                .filter((c) => c.checked)
                .map((c) => c.value);
            const checkedGroupsValues = this.groups
                .filter((g) => g.checked)
                .map((g) => g.value);
            const checkedStatusesValues = this.statuses
                .filter((s) => s.checked)
                .map((s) => s.value);
            let tempResultData;

            // get group filter list
            tempResultData = this.rawData.filter((row) => {
                if (
                    checkedClientsValues.length === 0 ||
                    (checkedClientsValues.indexOf(row.client_name) > -1 &&
                        checkedStatusesValues.length === 0) ||
                    checkedStatusesValues.indexOf(row.opportunity_set_status) >
                        -1
                ) {
                    return true;
                }
                return false;
            });
            const tempGroups = tempResultData.map((d) => d.opportunity_group);
            this.groups = this.groups.map((g) =>
                tempGroups.indexOf(g.value) > -1
                    ? { ...g, visible: true }
                    : { ...g, visible: false }
            );

            // get status filter list
            tempResultData = this.rawData.filter((row) => {
                if (
                    checkedClientsValues.length === 0 ||
                    (checkedClientsValues.indexOf(row.client_name) > -1 &&
                        checkedGroupsValues.length === 0) ||
                    checkedGroupsValues.indexOf(row.opportunity_group) > -1
                ) {
                    return true;
                }
                return false;
            });
            const tempOpps = tempResultData.map(
                (d) => d.opportunity_set_status
            );
            this.statuses = this.statuses.map((s) =>
                tempOpps.indexOf(s.value) > -1
                    ? { ...s, visible: true }
                    : { ...s, visible: false }
            );

            // get client filter list
            tempResultData = this.rawData.filter((row) => {
                if (
                    checkedStatusesValues.length === 0 ||
                    (checkedStatusesValues.indexOf(row.opportunity_set_status) >
                        -1 &&
                        checkedGroupsValues.length === 0) ||
                    checkedGroupsValues.indexOf(row.opportunity_group) > -1
                ) {
                    return true;
                }
                return false;
            });
            const tempClients = tempResultData.map((d) => d.client_name);
            this.clients = this.clients.map((c) =>
                tempClients.indexOf(c.value) > -1
                    ? { ...c, visible: true }
                    : { ...c, visible: false }
            );

            this.oppTableData = this.rawData.filter((row) => {
                if (
                    (checkedClientsValues.length === 0 ||
                        checkedClientsValues.indexOf(row.client_name) > -1) &&
                    (checkedGroupsValues.length === 0 ||
                        checkedGroupsValues.indexOf(row.opportunity_group) >
                            -1) &&
                    (checkedStatusesValues.length === 0 ||
                        checkedStatusesValues.indexOf(
                            row.opportunity_set_status
                        ) > -1)
                ) {
                    return true;
                }
                return false;
            });
        },
        onGridReady(params) {
            this.gridApi = params.api;
            this.totalRows = this.oppTableData.length;
            this.gridColumnApi = params.columnApi;
            this.gridApi.addEventListener(
                "paginationChanged",
                this.onPaginationChanged
            );

            // Initial pagination setup
            this.gridApi.paginationSetPageSize(this.selectedPageSize);
            this.currentPage = 1;

            // Fetch and set status options for the dropdown
            this.fetchProjectStatusOptions().then(() => {
                // After options are loaded, refresh the grid to ensure dropdown is properly configured
                if (this.gridApi) {
                    this.gridApi.refreshCells({ force: true });
                }
            });
        },
        onPaginationChanged(event) {
            if (this.gridApi) {
                const newPage = this.gridApi.paginationGetCurrentPage() + 1;
                if (newPage !== this.currentPage) {
                    this.currentPage = newPage;
                }

                // Update total rows count
                this.totalRows = this.gridApi.paginationGetRowCount();

                // Ensure current page is valid
                if (this.currentPage > this.totalPages) {
                    this.currentPage = this.totalPages || 1;
                    this.gridApi.paginationGoToPage(this.currentPage - 1);
                }
            }
        },
        actionCellRenderer(params) {
            const dropdown = document.createElement("select");

            dropdown.style.cssText = `
                padding: 8px 16px;
                font-size: 14px;
                border: 2px solid #e0e0e0;
                border-radius: 8px;
                background-color: #ffffff;
                cursor: pointer;
                min-width: 100px;
                transition: all 0.3s ease;
                color: #424242;
                font-weight: 400;
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                width: 120px;
            `;

            dropdown.innerHTML = `
                <option value="" disabled selected>Actions ⚡</option>
                <option value="import">📥 Import Items</option>
                <option value="edit">✏️ Edit Opportunity</option>
                <option value="delete">🗑️ Delete</option>
            `;

            dropdown.addEventListener("change", (event) => {
                const selectedValue = event.target.value;
                if (selectedValue === "import") {
                    this.importItemsClickHandler(params.data);
                } else if (selectedValue === "edit") {
                    this.editOpportunityClickHandler(params.data);
                } else if (selectedValue === "delete") {
                    this.showDeleteOpportunityModal = true;
                    this.editingItem = params.data;
                }
                event.target.selectedIndex = 0;
            });

            dropdown.addEventListener("mouseover", () => {
                dropdown.style.borderColor = "#ced2d8";
                dropdown.style.boxShadow = "0 2px 8px rgba(33, 150, 243, 0.15)";
                dropdown.style.transform = "translateY(-1px)";
            });

            dropdown.addEventListener("mouseout", () => {
                dropdown.style.borderColor = "#e0e0e0";
                dropdown.style.boxShadow = "none";
                dropdown.style.transform = "translateY(0)";
            });

            dropdown.addEventListener("focus", () => {
                dropdown.style.borderColor = "#2196f3";
                dropdown.style.boxShadow = "0 2px 8px rgba(33, 150, 243, 0.15)";
            });

            dropdown.addEventListener("blur", () => {
                dropdown.style.borderColor = "#e0e0e0";
                dropdown.style.boxShadow = "none";
            });

            return dropdown;
        },
        async createOppHandler() {
            this.isValidForAddingOpp = {
                priceForAddingOpp: true,
                percentForAddingOpp: true,
                modeForAddingOpp: true,
                clientForAddingOpp: !!this.clientForAddingOpp,
                groupForAddingOpp: !!this.groupForAddingOpp.trim(),
                categoryForAddingOpp: !!this.categoryForAddingOpp.trim(),
                projectIdForAddingOpp: !!this.projectIdForAddingOpp.trim(),
            };

            if (this.addOppModalHasError) {
                return;
            }

            await this.insertOpportunity();
        },
        editOpportunityClickHandler(item) {
            this.editingItem = item;
            this.showEditOpportunityModal = true;

            this.editingPrice = parseFloat(
                item.potential_savings.replace(/[^\d\.]/g, "")
            );
            this.editingPercent = item.savings_percent;
        },
        importItemsClickHandler(item) {
            console.log("item", item);

            this.editingItem = item;
            this.importItemsModal = true;

            this.editingPrice = parseFloat(
                item.potential_savings.replace(/[^\d\.]/g, "")
            );
            this.editingPercent = item.savings_percent;
        },
        initEditOpportunityModal() {
            this.editingItem = {};
            this.editOpportunityMode = "dollar";
            this.editingPrice = 0;
            this.editingPercent = 0;
        },
        async updateOpportunity() {
            this.spinner = true;
            await this.$apollo
                .mutate({
                    mutation: UPDATE_SPENDMD_DB_OPPORTUNITY_TEST,
                    variables: {
                        dollar_savings:
                            this.editOpportunityMode === "dollar"
                                ? this.editingPrice
                                : null,
                        savings_percent:
                            this.editOpportunityMode === "percent"
                                ? this.editingPercent / 100
                                : null,
                        opportunity_id: this.editingItem.opportunity_id,
                    },
                })
                .then((res) => {})
                .catch((err) => {
                    console.log(err);
                });

            await this.fetchOppTableData();
            this.spinner = false;
            this.showEditOpportunityModal = false;
        },
        async deleteOpportunity() {
            this.spinner = true;
            await this.$apollo
                .mutate({
                    mutation: DELETE_SPENDMD_DB_OPPORTUNITY_TEST_BY_PK,
                    variables: {
                        opportunity_id: this.editingItem.opportunity_id,
                    },
                })
                .then((res) => {})
                .catch((err) => {
                    console.log(err);
                });

            await this.fetchOppTableData();
            this.spinner = false;
            this.showDeleteOpportunityModal = false;
        },
        async exploreClickHandler(item, newStatus) {
            this.spinner = true;
            await this.$apollo
                .mutate({
                    mutation: UPDATE_OPPORTUNITY_SET_STATUS,
                    variables: {
                        opportunity_set_status: newStatus,
                        opportunity_id: item.opportunity_id,
                    },
                })
                .then((res) => {})
                .catch((err) => {
                    console.log(err);
                });

            await this.fetchOppTableData();
            this.spinner = false;
        },
        async fetchOppTableData() {
            await this.$apollo
                .mutate({
                    mutation: GET_OPPORTUNITY,
                    variables: {
                        clients: this.selectedClients,
                    },
                })
                .then((res) => {
                    console.log("res", res);
                    const tableRows =
                        res.data.spendmd_db_total_opportunity_with_null_aggregate.nodes.map(
                            (row) => ({
                                ...row,
                                included_vendors: this.parseVendors(
                                    row.included_vendors
                                ),
                                action: "actions placeholder",
                            })
                        );

                    this.rawData = tableRows;
                    this.oppTableData = tableRows;


                    if (this.gridApi && this.gridColumnApi) {
        this.$nextTick(() => {
            this.gridApi.refreshCells(); // ensure cells are rendered
            setTimeout(() => {
                this.gridColumnApi.autoSizeColumns([
                    'opportunity_category',
                    'opportunity_group',
                    'project_id',
                    'opportunity_priority'
]);
            }, 100); // slight delay ensures DOM is painted
        });
    }

                    // Reset pagination when data changes
                    if (this.gridApi) {
                        this.currentPage = 1;
                        this.gridApi.paginationGoToFirstPage();
                    }

                    const tempClients = tableRows.map((row) => row.client_name);
                    this.clients = [...new Set(tempClients)].map((row) => ({
                        label: row,
                        value: row,
                        checked: true,
                        visible: true,
                    }));

                    const tempGroups = tableRows.map(
                        (row) => row.opportunity_group
                    );
                    this.groups = [...new Set(tempGroups)].map((row) => ({
                        label: row,
                        value: row,
                        checked: true,
                        visible: true,
                    }));

                    const tempStatuses = tableRows
                        .map((row) => row.opportunity_set_status)
                        .filter((item) => !!item);
                    this.statuses = [...new Set(tempStatuses)].map((row) => ({
                        label: row,
                        value: row,
                        checked: true,
                        visible: true,
                    }));
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async insertOpportunity() {
            this.spinner = true;
            await this.$apollo
                .mutate({
                    mutation: INSERT_SPENDMD_DB_OPPORTUNITY_TEST_ONE,
                    variables: {
                        client_id: this.clientForAddingOpp.value,
                        client_name: this.clientForAddingOpp.label,
                        project_id: this.projectIdForAddingOpp.trim(),
                        opportunity_group: this.groupForAddingOpp.trim(),
                        opportunity_category: this.categoryForAddingOpp.trim(),
                        dollar_savings:
                            this.modeForAddingOpp === "TBD" ||
                            this.modeForAddingOpp === "percent"
                                ? null
                                : this.priceForAddingOpp,
                        savings_percent:
                            this.modeForAddingOpp === "TBD" ||
                            this.modeForAddingOpp === "dollar"
                                ? null
                                : this.percentForAddingOpp / 100,
                    },
                })
                .then((res) => {})
                .catch((err) => {
                    console.log(err);
                });

            await this.fetchOppTableData();
            this.spinner = false;
            this.showCreateOpportunityModal = false;
        },
        async exportHandler() {
            this.spinner = true;
            await this.$apollo
                .mutate({
                    mutation: SPENDMD_DB_OPPORTUNITY_TEST,
                    variables: {},
                })
                .then((res) => {
                    const testExportRows =
                        res.data.spendmd_db_opportunity_test.map((item) => {
                            const { __typename, ...refinedItem } = item;
                            return refinedItem;
                        });
                    const exportData = XLSX.utils.json_to_sheet(testExportRows);
                    const workBook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workBook, exportData, "Data");
                    XLSX.writeFile(workBook, "opportunity-test.xlsx");
                })
                .catch((err) => {
                    console.log(err);
                });

            this.spinner = false;
        },
        clearFiltersHandler() {
            this.gridApi.setFilterModel(null);
            this.oppTableData = this.rawData;
        },
        onPageSizeChange(newSize) {
            if (this.gridApi) {
                const currentFirstRow =
                    this.currentPage * this.selectedPageSize -
                    this.selectedPageSize;
                this.selectedPageSize = newSize.value;

                // Calculate new page number to maintain approximate position
                this.currentPage =
                    Math.floor(currentFirstRow / this.selectedPageSize) + 1;

                this.gridApi.paginationSetPageSize(newSize.value);
                this.gridApi.paginationGoToPage(this.currentPage - 1); // AG Grid uses 0-based page numbers
            }
        },
        onFirstPage() {
            if (this.gridApi) {
                this.gridApi.paginationGoToFirstPage();
                this.currentPage = 1;
            }
        },
        onPreviousPage() {
            if (this.gridApi) {
                this.gridApi.paginationGoToPreviousPage();
                this.currentPage--;
            }
        },
        onNextPage() {
            if (this.gridApi) {
                this.gridApi.paginationGoToNextPage();
                this.currentPage++;
            }
        },
        onLastPage() {
            if (this.gridApi) {
                this.gridApi.paginationGoToLastPage();
                this.currentPage = this.totalPages;
            }
        },
        vendorCellRenderer(params) {
            // Check if included_vendors exists and is an array
            if (
                !params.value ||
                !Array.isArray(params.value) ||
                params.value.length === 0
            ) {
                return "";
            }

            // By default show only the first vendor
            const container = document.createElement("div");
            container.innerHTML = params.value[0];
            container.title = "Click to see all vendors";
            container.style.cursor = "pointer";

            // Add a visual indicator that there are more vendors
            if (params.value.length > 1) {
                console.log(container.innerHTML);
                container.innerHTML = `(+${params.value.length - 1}) ` + container.innerHTML;
                
            }

            return container;
        },
        onVendorCellClicked(params) {
            if (!params.value || !Array.isArray(params.value)) {
                return;
            }
            this.selectedVendors = params.value;
            this.showVendorsModal = true;
        },
        parseVendors(vendors) {
            if (!vendors) return [];

            try {
                // First try to parse as JSON
                return JSON.parse(vendors);
            } catch (e) {
                // If JSON parsing fails, try to split by comma if it's a comma-separated string
                if (typeof vendors === "string") {
                    return vendors
                        .split(",")
                        .map((v) => v.trim())
                        .filter((v) => v);
                }
                // If it's already an array, return it
                if (Array.isArray(vendors)) {
                    return vendors;
                }
                // If it's a single string value, return it as an array
                if (typeof vendors === "string") {
                    return [vendors];
                }
                // Default to empty array if none of the above work
                return [];
            }
        },
        onStatusChanged(params) {
            if (params.oldValue !== params.newValue) {
                this.updateOpportunityStatus(params.data.opportunity_id, params.newValue);
            }
        },
        onPriorityChanged(params) {
            if (params.oldValue !== params.newValue) {
                this.updateOpportunityPriority(params.data.opportunity_id, parseInt(params.newValue));
            }
        },
        onSavingsChanged(params) {
            if (params.oldValue !== params.newValue) {
                // Parse the dollar amount from the input, removing currency symbols and commas
                const dollarValue = parseFloat(params.newValue.replace(/[$,]/g, ''));
                if (!isNaN(dollarValue)) {
                    this.updateOpportunitySavings(params.data.opportunity_id, dollarValue, null);
                } else {
                    // Revert to old value if parsing fails
                    params.node.setDataValue(params.column.colId, params.oldValue);
                }
            }
        },
        onPercentChanged(params) {
            if (params.oldValue !== params.newValue) {
                // Parse the percentage value
                const percentValue = parseFloat(params.newValue.replace(/%/g, ''));
                if (!isNaN(percentValue)) {
                    this.updateOpportunitySavings(params.data.opportunity_id, null, percentValue / 100);
                } else {
                    // Revert to old value if parsing fails
                    params.node.setDataValue(params.column.colId, params.oldValue);
                }
            }
        },
        onProjectIdChanged(params) {
            if (params.oldValue !== params.newValue) {
                // Validate project ID format
                const regex = /^[A-Z]{2}-\d{3}\.\d{3}$/;
                if (regex.test(params.newValue)) {
                    this.updateProjectId(params.data.opportunity_id, params.newValue);
                } else {
                    // Revert to old value if validation fails
                    params.node.setDataValue(params.column.colId, params.oldValue);
                    // Show error toast or notification if needed
                    console.error('Invalid project ID format. Use AA-000.000 format.');
                }
            }
        },
        onOpportunityCategoryChanged(params) {
            if (params.oldValue !== params.newValue) {
                if (params.newValue && params.newValue.trim() !== '') {
                    this.updateOpportunityCategory(params.data.opportunity_id, params.newValue.trim());
                } else {
                    // Revert to old value if empty
                    params.node.setDataValue(params.column.colId, params.oldValue);
                }
            }
        },
        onOpportunityGroupChanged(params) {
            if (params.oldValue !== params.newValue) {
                if (params.newValue && params.newValue.trim() !== '') {
                    this.updateOpportunityGroup(params.data.opportunity_id, params.newValue.trim());
                } else {
                    // Revert to old value if empty
                    params.node.setDataValue(params.column.colId, params.oldValue);
                }
            }
        },
        async updateOpportunitySavings(id, dollarSavings, savingsPercent) {
            this.spinner = true;
            try {
                await this.$apollo.mutate({
                    mutation: UPDATE_SPENDMD_DB_OPPORTUNITY_TEST,
                    variables: {
                        opportunity_id: id,
                        dollar_savings: dollarSavings,
                        savings_percent: savingsPercent
                    }
                });
                // Refresh data after update
                await this.fetchOppTableData();
            } catch (err) {
                console.error('Error updating opportunity savings:', err);
            } finally {
                this.spinner = false;
            }
        },
        async updateOpportunityStatus(id, status) {
            this.spinner = true;
            try {
                await this.$apollo.mutate({
                    mutation: UPDATE_OPPORTUNITY_STATUS,
                    variables: {
                        id: id,
                        opportunity_status: status
                    }
                });
                // Refresh data after update
                await this.fetchOppTableData();
            } catch (err) {
                console.error('Error updating opportunity status:', err);
            } finally {
                this.spinner = false;
            }
        },
        async updateOpportunityPriority(id, priority) {
            this.spinner = true;
            try {
                await this.$apollo.mutate({
                    mutation: UPDATE_OPPORTUNITY_PRIORITY,
                    variables: {
                        id: id,
                        opportunity_priority: priority
                    }
                });
                // Refresh data after update
                await this.fetchOppTableData();
            } catch (err) {
                console.error('Error updating opportunity priority:', err);
            } finally {
                this.spinner = false;
            }
        },
        async fetchProjectStatusOptions() {
            try {
                const { data } = await this.$apollo.query({
                    query: PROJECT_STATUS_OPTIONS
                });

                // Map the options for the select editor using only description
                this.projectStatusOptions = data.spendmd_db_project_status.map(option =>
                    option.description || `Status ${option.id}`
                );

                // Update column definitions with these options
                if (this.gridApi) {
                    // First update our column definition
                    const columnDefs = [...this.columnDefs];
                    const statusColDef = columnDefs.find(col => col.field === 'opportunity_set_status');
                    if (statusColDef) {
                        statusColDef.cellEditorParams = {
                            values: [...this.projectStatusOptions]
                        };

                        // Set the updated column definitions
                        this.columnDefs = columnDefs;
                        this.gridApi.setColumnDefs(columnDefs);

                        // Force refresh cells to ensure the changes take effect
                        this.gridApi.refreshCells({ force: true });

                        console.log('Updated status options:', this.projectStatusOptions);
                    }
                }
            } catch (err) {
                console.error('Error fetching project status options:', err);
            }
        },
        async updateProjectId(id, projectId) {
            this.spinner = true;
            try {
                await this.$apollo.mutate({
                    mutation: UPDATE_PROJECT_ID,
                    variables: {
                        id: id,
                        project_id: projectId
                    }
                });
                // Refresh data after update
                await this.fetchOppTableData();
            } catch (err) {
                console.error('Error updating project ID:', err);
            } finally {
                this.spinner = false;
            }
        },
        async updateOpportunityCategory(id, category) {
            this.spinner = true;
            try {
                await this.$apollo.mutate({
                    mutation: UPDATE_OPPORTUNITY_CATEGORY,
                    variables: {
                        id: id,
                        opportunity_category: category
                    }
                });
                // Refresh data after update
                await this.fetchOppTableData();
            } catch (err) {
                console.error('Error updating opportunity category:', err);
            } finally {
                this.spinner = false;
            }
        },
        async updateOpportunityGroup(id, group) {
            this.spinner = true;
            try {
                await this.$apollo.mutate({
                    mutation: UPDATE_OPPORTUNITY_GROUP,
                    variables: {
                        id: id,
                        opportunity_group: group
                    }
                });
                // Refresh data after update
                await this.fetchOppTableData();
            } catch (err) {
                console.error('Error updating opportunity group:', err);
            } finally {
                this.spinner = false;
            }
        },
    },
    async mounted() {
        if (!this.isSysAdmin && !this.isGroupAdmin) {
            this.columnDefs = this.columnDefs.filter(
                (item) => item.field !== "client_name"
            );
        }

        this.spinner = true;
        await this.fetchOppTableData();
        this.spinner = false;
    },
};

const GET_OPPORTUNITY = gql`
    query ($clients: json) {
        spendmd_db_total_opportunity_with_null_aggregate(
            args: { clients: $clients }
        ) {
            nodes {
                project_id
                client_id
                client_name
                included_vendors
                opportunity_id
                opportunity_group
                opportunity_category
                total_spend
                sku_count
                potential_savings
                savings_percent
                opportunity_set_status
                opportunity_priority
            }
            aggregate {
                sum {
                    sum_total_spend: total_spend
                    sum_potential_savings: potential_savings
                }
            }
        }
    }
`;

const UPDATE_OPPORTUNITY_SET_STATUS = gql`
    mutation ($opportunity_set_status: String!, $opportunity_id: Int!) {
        update_spendmd_db_opportunity_test(
            _set: { opportunity_set_status: $opportunity_set_status }
            where: { id: { _eq: $opportunity_id } }
        ) {
            returning {
                id
            }
        }
    }
`;

const UPDATE_SPENDMD_DB_OPPORTUNITY_TEST = gql`
    mutation (
        $dollar_savings: money
        $savings_percent: numeric
        $opportunity_id: Int!
    ) {
        update_spendmd_db_opportunity_test(
            where: { id: { _eq: $opportunity_id } }
            _set: {
                dollar_savings: $dollar_savings
                savings_percent: $savings_percent
            }
        ) {
            returning {
                id
            }
        }
    }
`;

const DELETE_SPENDMD_DB_OPPORTUNITY_TEST_BY_PK = gql`
    mutation ($opportunity_id: Int! = 161) {
        delete_spendmd_db_opportunity_match(
            where: { opportunity_id: { _eq: $opportunity_id } }
        ) {
            returning {
                id
            }
        }

        delete_spendmd_db_opportunity_test_by_pk(id: $opportunity_id) {
            id
        }
    }
`;

const INSERT_SPENDMD_DB_OPPORTUNITY_TEST_ONE = gql`
    mutation (
        $client_id: uuid!
        $project_id: String!
        $client_name: String!
        $opportunity_group: String!
        $opportunity_category: String!
        $dollar_savings: money
        $savings_percent: numeric
    ) {
        insert_spendmd_db_opportunity_test_one(
            object: {
                client_id: $client_id
                client_name: $client_name
                project_id: $project_id
                opportunity_group: $opportunity_group
                opportunity_category: $opportunity_category
                dollar_savings: $dollar_savings
                savings_percent: $savings_percent
            }
        ) {
            id
        }
    }
`;

const SPENDMD_DB_OPPORTUNITY_TEST = gql`
    query {
        spendmd_db_opportunity_test {
            client_name
            opportunity_group
            opportunity_category
            dollar_savings
            savings_percent
        }
    }
`;

const PROJECT_STATUS_OPTIONS = gql`
    query project_status_options {
        spendmd_db_project_status {
            id
            description
        }
    }
`;

const UPDATE_OPPORTUNITY_STATUS = gql`
    mutation updateOpportunityStatus(
        $id: Int!
        $opportunity_status: String
    ) {
        update_spendmd_db_opportunity_test_by_pk(
            pk_columns: {
                id: $id
            }
            _set: {
                opportunity_set_status: $opportunity_status
            }
        ) {
            id
        }
    }
`;

const UPDATE_OPPORTUNITY_PRIORITY = gql`
    mutation updateOpportunityPriority(
        $id: Int!
        $opportunity_priority: Int
    ) {
        update_spendmd_db_opportunity_test_by_pk(
            pk_columns: {
                id: $id
            }
            _set: {
                opportunity_priority: $opportunity_priority
            }
        ) {
            id
        }
    }
`;

const UPDATE_PROJECT_ID = gql`
    mutation updateProjectId(
        $id: Int!
        $project_id: String
    ) {
        update_spendmd_db_opportunity_test_by_pk(
            pk_columns: {
                id: $id
            }
            _set: {
                project_id: $project_id
            }
        ) {
            id
        }
    }
`;

const UPDATE_OPPORTUNITY_CATEGORY = gql`
    mutation updateOpportunityCategory(
        $id: Int!
        $opportunity_category: String
    ) {
        update_spendmd_db_opportunity_test_by_pk(
            pk_columns: {
                id: $id
            }
            _set: {
                opportunity_category: $opportunity_category
            }
        ) {
            id
        }
    }
`;

const UPDATE_OPPORTUNITY_GROUP = gql`
    mutation updateOpportunityGroup(
        $id: Int!
        $opportunity_group: String
    ) {
        update_spendmd_db_opportunity_test_by_pk(
            pk_columns: {
                id: $id
            }
            _set: {
                opportunity_group: $opportunity_group
            }
        ) {
            id
        }
    }
`;
</script>

<style scoped>
.opp-table-wrapper {
    text-align: center;
}

.radio-text-input {
    margin: 0.5rem 0 0.5rem 1.25rem;
    width: calc(100% - 1.25rem);
}

.opportunity-input {
    padding: 0;
    margin-bottom: 1.5rem;
}

.input-error {
    color: red;
}

.input-error::v-deep > .v-select {
    border: 1px solid red;
}

.input-error::v-deep > input {
    border: 1px solid red;
}

.error-message {
    color: red;
    font-size: 0.9em;
    margin-top: 5px;
}

/* Pagination Dropdown Styles */
::v-deep .ag-paging-panel {
    color: #333;
    height: 50px;
    padding: 0 16px;
    display: flex;
    align-items: center;
}

::v-deep .ag-paging-page-size-select {
    width: 80px;
    height: 32px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 0 8px;
    margin: 0 8px;
    background-color: white;
    cursor: pointer;
    font-size: 14px;
}

::v-deep .ag-paging-page-size-select:focus {
    outline: none;
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

::v-deep .ag-paging-page-size-select:hover {
    border-color: #80bdff;
}

.custom-pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
}

.pagination-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.pagination-right {
    display: flex;
    align-items: center;
    gap: 8px;
}

.pagination-btn {
    padding: 4px 8px;
    border: 1px solid #dee2e6;
    background-color: white;
    border-radius: 4px;
    cursor: pointer;
    min-width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pagination-btn:hover:not(:disabled) {
    background-color: #e9ecef;
    border-color: #dee2e6;
}

.pagination-btn:disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.pagination-info {
    padding: 0 12px;
    color: #6c757d;
}

/* Style the v-select component */
::v-deep .v-select {
    background-color: white;
    border-radius: 4px;
}

::v-deep .v-select .vs__dropdown-toggle {
    border-color: #ced4da;
    height: 32px;
    min-height: 32px;
    padding: 0 8px;
}

::v-deep .v-select .vs__selected {
    margin: 0;
    padding: 0;
}

::v-deep .v-select .vs__dropdown-menu {
    min-width: 80px;
}

::v-deep .v-select .vs__actions {
    padding: 0;
}

::v-deep .v-select .vs__clear {
    display: none;
}

.vendor-modal-content {
    padding: 0;
    min-width: auto;
    width: 100%;
}

.vendor-count {
    background: #f8f9fa;
    padding: 16px 24px;
    font-weight: 600;
    color: #495057;
    border-bottom: 1px solid #dee2e6;
    margin: -16px -16px 16px -16px;
    font-size: 16px;
}

.vendor-list {
    max-height: 400px;
    overflow-y: auto;
    margin: 0 -16px;
}

.vendor-item {
    display: flex;
    align-items: center;
    padding: 16px 24px;
    border-bottom: 1px solid #eee;
    transition: background-color 0.2s ease;
}

.vendor-item:hover {
    background-color: #f8f9fa;
}

.vendor-item:last-child {
    border-bottom: none;
}

.vendor-number {
    width: 24px;
    height: 24px;
    background: #e9ecef;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    color: #495057;
    margin-right: 12px;
    flex-shrink: 0;
}

.vendor-name {
    font-size: 15px;
    color: #212529;
    line-height: 1.4;
    padding-right: 16px;
}

/* Custom scrollbar for the vendor list */
.vendor-list::-webkit-scrollbar {
    width: 8px;
}

.vendor-list::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.vendor-list::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
}

.vendor-list::-webkit-scrollbar-thumb:hover {
    background: #999;
}

::v-deep .vendor-modal .modal-dialog {
    max-width: 500px;
    width: 100%;
}
</style>
